"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var _Core_1 = require("../../../_Core");
var Localization_1 = require("../../../Localization");
var PhotoUpload_styles_1 = require("./PhotoUpload.styles");
var defaultAcceptedFileTypes = ["image/png", "image/jpg", "image/jpeg", "image/bmp"];
var defaultAcceptedFileSizeBytesMax = 4194304; // defaulting to 4mb;
exports.default = (function (_a) {
    var _b = _a.AcceptedFileTypes, AcceptedFileTypes = _b === void 0 ? defaultAcceptedFileTypes : _b, _c = _a.MaximumFileSize, MaximumFileSize = _c === void 0 ? defaultAcceptedFileSizeBytesMax : _c, OnFileHasBeenAccepted = _a.OnFileHasBeenAccepted;
    var uploadWrapper = React.createRef();
    var _d = React.useState({ ScreenState: "Ready" }), dropState = _d[0], setDropState = _d[1];
    var isFileTypeAccepted = function (type) {
        var acceptable = AcceptedFileTypes.filter(function (e) { return e === type; });
        return acceptable.length > 0;
    };
    var processFilesFromInputControl = function (files) {
        if (files.length !== 1) {
            setDropState({
                ErrorMessage: Localization_1.strings.UploadAvatar_Message_ErrorMultipleFiles,
                ScreenState: "DropFileRejected",
            });
        }
        else {
            var file_1 = files.item(0);
            if (!isFileTypeAccepted(file_1.type) || file_1.size > MaximumFileSize) {
                setDropState({
                    ErrorMessage: buildErrorMessage(),
                    ScreenState: "DropFileRejected",
                });
            }
            else {
                var reader_1 = new FileReader();
                reader_1.onload = function () { return OnFileHasBeenAccepted(reader_1.result.toString(), file_1); };
                reader_1.onerror = function () { return setDropState({ ScreenState: "DropFileRejected", ErrorMessage: Localization_1.strings.UploadAvatar_Message_UnknownError }); };
                reader_1.readAsDataURL(file_1);
            }
        }
    };
    var buildErrorMessage = function () {
        var formattedBytes = _Core_1.FormatBytes(MaximumFileSize);
        var fileTypes = _Core_1.ReplaceLastOccurrence(AcceptedFileTypes.map(function (e) { return e.replace("image/", ""); }).join(", "), ",", " or");
        var errMessage = Localization_1.strings.formatString(Localization_1.strings.UploadAvatar_Message_UnableToUploadMessage, fileTypes, formattedBytes.toString()).toString();
        return errMessage;
    };
    var handleFileDragLeave = function (e) {
        e.preventDefault();
        e.stopPropagation();
        setDropState({ ScreenState: "Ready" });
    };
    var handleFileDragOver = function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (isFileTypeAccepted(e.dataTransfer.items[0].type)) {
            setDropState({ ScreenState: "AllowDrop" });
        }
        else {
            setDropState({ ScreenState: "InvalidFile", ErrorMessage: Localization_1.strings.UploadAvatar_Message_InvalidFileType });
        }
    };
    var handleFileDrop = function (e) {
        e.preventDefault();
        e.stopPropagation();
        var dataTransfer = e.dataTransfer;
        var files = dataTransfer.files;
        processFilesFromInputControl(files);
    };
    var handleFileInputChange = function (e) {
        processFilesFromInputControl(e.target.files);
    };
    // this code is likely to change when Joes design
    // on errors comes thru.
    React.useEffect(function () {
        var timeoutClear;
        if (dropState.ScreenState === "DropFileRejected") {
            timeoutClear = window.setTimeout(function () {
                setDropState({ ScreenState: "Ready" });
            }, 2000);
        }
        return function () {
            window.clearTimeout(timeoutClear);
        };
    }, [dropState.ScreenState]);
    return (React.createElement(PhotoUpload_styles_1.UploadWrapper, { ref: uploadWrapper, HoverState: dropState.ScreenState, onDragEnter: handleFileDragOver, onDragOver: handleFileDragOver, onDragLeave: handleFileDragLeave, onDrop: handleFileDrop },
        dropState.ScreenState === "DropFileRejected" && (React.createElement(PhotoUpload_styles_1.ErrorWrapper, { onClick: function () { return setDropState({ ScreenState: "Ready" }); } },
            React.createElement(PhotoUpload_styles_1.ErrorHeader, null, Localization_1.strings.UploadAvatar_Message_UnableToUploadTitle),
            React.createElement(PhotoUpload_styles_1.ErrorText, null, dropState.ErrorMessage))),
        dropState.ScreenState === "InvalidFile" && React.createElement("p", null, dropState.ErrorMessage),
        (dropState.ScreenState === "Ready" || dropState.ScreenState === "AllowDrop") &&
            (React.createElement("form", null,
                React.createElement("p", null,
                    Localization_1.strings.UploadAvatar_Label_DragDrop1,
                    " ",
                    React.createElement(PhotoUpload_styles_1.FileUploadInput, { id: "file-upload-input", type: "file", multiple: false, accept: AcceptedFileTypes.join(","), onChange: handleFileInputChange, title: Localization_1.strings.UploadAvatar_Label_UploadFile }),
                    React.createElement(PhotoUpload_styles_1.FileUploadLabel, { htmlFor: "file-upload-input" }, Localization_1.strings.UploadAvatar_Label_DragDrop2))))));
});
